import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { PartnerDto, PaymentResponseDto, SchoolBillDto } from '../api/models';

import { QRCodeComponent } from 'angularx-qrcode';
import { ReceiptControllerService, SchoolBillControllerService, SchoolControllerService } from '../api/services';
import * as bootstrap from 'bootstrap';
import {  AngularDeviceInformationService } from 'angular-device-information';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { environment } from '../../environments/environment';
import { constants } from '../common/constants';

@Component({
  selector: 'app-school-payment',
  imports: [
    ReactiveFormsModule,
    QRCodeComponent,CommonModule,
    RouterLink
],
  templateUrl: './school-payment.component.html',
  styleUrl: './school-payment.component.css'
})
export class SchoolPaymentComponent implements OnInit {



  message ='';
  paymentNetwork='';
  fees =0;
  isWallet=false;
  isBill=true;
  isPayment =false;
 
  qrCode='';
  formPay:FormGroup;
  formBill:FormGroup;
  schools?:Array<PartnerDto>;
  paymentNetworkOtpion='';
  qrSchool?:PartnerDto;
  idSchool?:number;
  taxe=0;
  idStudent=''

  isQrCode=false;

  bills:Array<SchoolBillDto> = [];
  selectedBill=false;
  bill:SchoolBillDto={};
  showAnticipationLnk=false;
  idempotencyKey = '';
  processing=false;
  paymentMeans:Array<any>=[];

  constructor(private formBuilder:FormBuilder,
    private schoolService:SchoolControllerService,
    private billService:SchoolBillControllerService,
    private receiptService:ReceiptControllerService,
    private activeRoute:ActivatedRoute,
    private route:Router,
    private deviceInfo:AngularDeviceInformationService
  ){

    this.formPay = this.formBuilder.group({
      phone:['']
    });
    this.formBill = this.formBuilder.group({
      school:[Validators.required],
      idStudent:['',Validators.required]
    });
  }
  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(p=>{
      this.idSchool=p['idSchool'];
    })
    this.loadSchool(this.idSchool);
    console.log(this.isBill);
    
    this.paymentMeans =constants.getPaymentNetworks(environment.codeCountry);
  }
  

  processPayment(){
    this.processing=true;
    if(this.idempotencyKey==''){
      this.idempotencyKey = crypto.randomUUID();
    

    this.billService.pay1({
      idBill:this.bill.id!!,
      paymentNetwork:this.paymentNetwork,
      paymentMean:this.formPay.value.phone,
      payNetworkOption:this.paymentNetworkOtpion
    }).subscribe(
      {
        next:(resp)=>{
          this.processing=false;
          this.idempotencyKey = '';
          if(resp.status =='PENDING'){
            if(this.paymentNetwork.toUpperCase() == 'OMSN'){
              this.handleOrangemoneyResponse(resp);
            }else{
              if(resp.paymentUrl){
                this.openUrl(resp.paymentUrl);
              }
            }
          
        }

        },
        error:(err)=>{
          this.processing=false;
          this.idempotencyKey = '';
          this.message =err.error.message;
          const elt =document.getElementById('modErrPay');
                           const modAdd = new bootstrap.Modal(elt!!);
                           modAdd.show();
        }
      }
    );
  } else {
    this.message ='Le paiement est en cours de traitement. Veuillez patienter.';
    const elt =document.getElementById('modErrPay');
                             const modAdd = new bootstrap.Modal(elt!!);
                             modAdd.show();
  }
  }
  isValid(){
    let valid =false;
    if(this.paymentNetwork.toLocaleLowerCase() =='card'){
      valid = true;
    }else {
      let phone = this.formPay.value.phone;
      if(this.paymentNetwork.toUpperCase() =='OMSN'){
        if(this.deviceInfo.isDesktop()){
          this.paymentNetworkOtpion ='qrcode';
        }else {
          this.paymentNetworkOtpion='maxit';
        }

      }
      valid = phone!=null&&phone.length>=9;

    }
    return valid;
  }
  completeForm(paymentNetwork:string){

    this.formPay.reset();
    this.paymentNetwork = paymentNetwork;
    const methods = document.querySelectorAll('.payment-method');

    if(this.paymentNetwork.toLocaleLowerCase() == 'card'){
      this.isWallet = false;
   
    }else {
      this.isWallet =true;

    }

    methods.forEach(element => {
      
      if(element.getAttribute('data-method') == paymentNetwork){
        element.classList.add('active');

      }else {
        element.classList.remove('active');
      }
      
    });

  }
  onSelectPaymentMethod(paymentMethod:any){
    
    this.isWallet = paymentMethod.isMobileMoney;
    this.billService.getFeesAndTaxes({
      idBill:this.bill.id!!,
      paymentMode:paymentMethod.code
    }).subscribe(
      {
        next:(resp) =>{
          this.taxe =resp.taxes;
          this.fees =resp.fees-this.taxe;
          this.completeForm(paymentMethod.code);
          
        },
        error:(err)=>{
            console.log("eer"+err.error.message);
            
            this.message =err.error.message;
            const elt =document.getElementById('modErrPay');
                             const modAdd = new bootstrap.Modal(elt!!);
                             modAdd.show();
        }
      }
    );

  }
  loadSchool(school?:number){

    this.schoolService.findSchool(
      environment.codeParent,
      environment.codeCountry,
      school
    ).subscribe(
      {
        next:(resp)=>{
          this.schools=resp;
          this.isQrCode=false;
          if(school!!>0){
          this.qrSchool =resp.at(0);
          this.isQrCode =true;
        }
        }
      }
    );
  }
  findBill(){
    let form =this.formBill.value;

    this.billService.findBillByStudent1(
      form.idStudent,
      form.school
    ).subscribe(
      {
        next:(resp)=>{
          this.bills =resp;
          this.isBill=false;
          this.isPayment=true;
          if(this.bills.length ==1){
            this.bill = this.bills.at(0)!!;
            this.selectedBill=true;
          }
        },
        error:(err)=>{
         
         
          this.message = err.error.message;
          this.showAnticipationLnk= err.error.code=='1000';
          this.idSchool = form.school;
          this.idStudent = form.idStudent;
           const elt =document.getElementById('modErrPay');
                           const modAdd = new bootstrap.Modal(elt!!);
                           modAdd.show();
        }
      }
    )

  }
  handleOrangemoneyResponse(resp:PaymentResponseDto){
      console.log('orange money');
      if(resp.status =='PENDING'){
        if(this.paymentNetworkOtpion=='maxit'){
          if(resp.paymentUrl){
          this.openUrl(resp.paymentUrl);
          }
        }else {
          this.qrCode =resp.qrCode!!;
          console.log(this.qrCode);
          this.isPayment =false;
          this.finalizePayment(resp.reference!!);
          
        }
      }
  
    }
    async finalizePayment(reference:string){
      
      this.receiptService.getPaymentDetails(
        reference
      ).subscribe({
        next:(resp)=>{
          console.log(resp);
          if(resp.status =='PENDING'){
            setTimeout(()=>
              {
                this.finalizePayment(reference);
              },
              20000);
          }else {
            this.route.navigateByUrl('receipt/'+reference);
            
          }
          
        },
        
      });
     
    }
    openUrl(url:string){
  
       window.open(url,'_self');
    }

    onSelectBill(bill:SchoolBillDto){
      this.bill = bill;
      this.selectedBill=true;
    }
    
}
